import React, { useState } from "react";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DeleteIcon from "@mui/icons-material/Delete";
import DescriptionIcon from "@mui/icons-material/Description";
import EditIcon from "@mui/icons-material/Edit";
import ScheduleIcon from "@mui/icons-material/Schedule";

import {
  InfoCard,
  CardItemContainer,
  CardTypeDiv,
  CardType,
  CardTitle,
  CardUniversity,
  CardGroupDiv,
  CardRowWithIcon,
  CardRow,
  TopBarActions,
  IconContainer,
} from "./styled";
import { CreateNewAcademicModal } from "../AcademicModal";
import api from "../../api/axios";
import { toast } from "react-toastify";

export const AcademicInfoCard = ({
  course,
  userData,
  getData,
  hideActions = false,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const closeModal = () => {
    setModalOpen(false);
    setModalType("");
    getData();
  };

  const handleDeleteClick = async () => {
    setModalType("delete");
    setModalOpen(true);
  };

  const handleEditClick = async () => {
    setModalType("edit");
    setModalOpen(true);
  };

  const handleCertificateClick = async (url) => {
    const res = await api.post("/professional/get-signed-url", {
      url,
    });
    if (res.status === 200) {
      window.open(res.data.signedUrl, "_blank");
    } else {
      toast.error("Ocorreu um erro");
    }
  };

  return (
    <>
      <InfoCard>
        <CardItemContainer>
          <CardTypeDiv>
            <CardType>{course.type}</CardType>
          </CardTypeDiv>
          {hideActions ? (
            <></>
          ) : (
            <TopBarActions>
              <IconContainer onClick={handleDeleteClick}>
                <DeleteIcon />
              </IconContainer>
              <IconContainer onClick={handleEditClick}>
                <EditIcon />
              </IconContainer>
            </TopBarActions>
          )}
        </CardItemContainer>
        <CardItemContainer>
          <CardTitle>{course.course}</CardTitle>
        </CardItemContainer>
        <CardItemContainer>
          <CardGroupDiv>
            <CardUniversity>{course.origin}</CardUniversity>
            <CardUniversity>{course.year}</CardUniversity>
          </CardGroupDiv>
        </CardItemContainer>
        <CardItemContainer>
          <CardGroupDiv>
            <CardRowWithIcon>
              <CalendarMonthIcon fontSize="small" sx={{ color: "#104467" }} />
              <CardRow>Modalidade: {course.deliveryMode}</CardRow>
            </CardRowWithIcon>
            <CardRowWithIcon>
              <ScheduleIcon fontSize="small" sx={{ color: "#104467" }} />
              <CardRow>Carga horária: {course.duration} horas</CardRow>
            </CardRowWithIcon>
            <CardRowWithIcon>
              <DescriptionIcon fontSize="small" sx={{ color: "#104467" }} />
              <CardRow>
                Certificado:{" "}
                {course.certificate ? (
                  <span
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCertificateClick(course.certificate)}
                  >
                    Link
                  </span>
                ) : (
                  "Indisponível"
                )}
              </CardRow>
            </CardRowWithIcon>
          </CardGroupDiv>
        </CardItemContainer>
      </InfoCard>
      <CreateNewAcademicModal
        open={modalOpen}
        onClose={closeModal}
        user={userData}
        type={modalType}
        course={course}
      />
    </>
  );
};
